import { render, staticRenderFns } from "./BackgroundChanger.vue?vue&type=template&id=5c861158&scoped=true&"
import script from "./BackgroundChanger.vue?vue&type=script&lang=js&"
export * from "./BackgroundChanger.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundChanger.vue?vue&type=style&index=0&id=5c861158&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c861158",
  null
  
)

export default component.exports